import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { SubProductGroupActions, SubProductGroupStore, STATUS } from 'Stores/subProductGroupStore'
import SubProductGroupForm from 'Modules/subProductGroup/subProductGroupForm'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input } from 'reactstrap'
import { Box } from '@material-ui/core'

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #23282c;
  font-weight: 400;
`

export default class SubProductGroupEdit extends Component {
  constructor(props) {
    super(props)
    this.stores = [SubProductGroupStore]
    this.storeKeys = ['status', 'subProductGroupDetails']
    this.state = {
      showAddSubProductModal: false,
      subProductID: null
    }
  }

  componentDidMount() {
    SubProductGroupActions.getSubProductGroupDetails(this.props.match.params.SubProductGroupID)
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.UPDATE_SUCCESS) {
      toast.success('SubProductGroup Updated', {
        autoClose: 3000,
        onClose: () => {
          SubProductGroupActions.clearFormToast()
        }
      })
      SubProductGroupActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.UPDATE_ERROR) {
      toast.error('SubProductGroup Update Failed', {
        autoClose: 3000,
        onClose: () => {
          SubProductGroupActions.clearFormToast()
        }
      })
      SubProductGroupActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.UPDATE_SUCCESS) {
      toast.success('SubProductGroup Updated', {
        autoClose: 3000,
        onClose: () => {
          SubProductGroupActions.clearFormToast()
        }
      })
      SubProductGroupActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.ADD_SUB_PRODUCT_SUCCESS) {
      toast.success('Sub Product Added', {
        autoClose: 3000,
        onClose: () => {
          SubProductGroupActions.clearFormToast()
        }
      })
    }
    if (this.state.status === STATUS.ADD_SUB_PRODUCT_ERROR) {
      toast.error('Adding Sub Product Failed', {
        autoClose: 3000,
        onClose: () => {
          SubProductGroupActions.clearFormToast()
        }
      })
    }
    if (this.state.status === STATUS.REMOVE_SUB_PRODUCT_SUCCESS) {
      toast.success('Sub Product Removed', {
        autoClose: 3000,
        onClose: () => {
          SubProductGroupActions.clearFormToast()
        }
      })
    }
    if (this.state.status === STATUS.REMOVE_SUB_PRODUCT_ERROR) {
      toast.error('Removing Sub Product Failed', {
        autoClose: 3000,
        onClose: () => {
          SubProductGroupActions.clearFormToast()
        }
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        <SubProductGroupForm match={this.props.match} />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button onClick={() => this.setState({ showAddSubProductModal: true })}>Tilføj Subprodukt</Button>
        </Box>
        <CollapsibleCard startOpen header={<strong>{'Subprodukter'}</strong>}>
          <DynamicTable
            responsive
            size='sm'
            options={{
              startSort: {
                dir: 'DESC',
                column: 'ProductID'
              },
              fieldFunctions: {
                elementTitle: e => {
                  return <StyledLink to={`/products/${e.ProductID}`}>{e.elementTitle}</StyledLink>
                },
                action: e => {
                  return (
                    <Button color='danger' size='sm' onClick={() => SubProductGroupActions.removeSubProduct(e.ProductID)}>
                      Fjern
                    </Button>
                  )
                }
              },
              fieldStringFunctions: {},
              fieldExportFunctions: {}
            }}
            headers={{
              ProductID: '#',
              elementTitle: 'Produkt',
              action: 'Handling'
            }}
            data={this.state.subProductGroupDetails.subProducts}
          />
        </CollapsibleCard>

        <CollapsibleCard startOpen header={<strong>{'Produkter'}</strong>}>
          <DynamicTable
            responsive
            size='sm'
            options={{
              startSort: {
                dir: 'DESC',
                column: 'ProductID'
              },
              fieldFunctions: {
                elementTitle: e => {
                  return <StyledLink to={`/products/${e.ProductID}`}>{e.elementTitle}</StyledLink>
                }
              },
              fieldStringFunctions: {},
              fieldExportFunctions: {}
            }}
            headers={{
              ProductID: '#',
              elementTitle: 'Produkt'
            }}
            data={this.state.subProductGroupDetails.products}
          />
        </CollapsibleCard>

        {this.state.showAddSubProductModal && (
          <Modal
            isOpen={!!this.state.showAddSubProductModal}
            toggle={() => this.setState({ showAddSubProductModal: !this.state.showAddSubProductModal })}
            size='md'
          >
            <ModalHeader toggle={() => this.setState({ showAddSubProductModal: !this.state.showAddSubProductModal })}>Tilføj Subprodukt</ModalHeader>
            <ModalBody>
              <Label>Produkt ID</Label>
              <Input
                type='number'
                id='subProductID'
                name='subProductID'
                onChange={event => this.setState({ subProductID: Number(event.target.value) })}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                onClick={() => {
                  if (this.state.subProductID) {
                    SubProductGroupActions.addSubProduct(this.state.subProductID)
                    this.setState({ showAddSubProductModal: false, subProductID: null })
                  }
                }}
              >
                Ok
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </React.Fragment>
    )
  }
}
